/* eslint-disable prettier/prettier */
import React, {useState} from 'react';
import StandingsTable from "./Tables/StandingsTable";
import StandingsFilter from "./Filters/StandingsFilter";
import {useStandings} from "../../hooks/standings";

function Standings({ show }) {
    if (!show) return null;
    const [season, setSeason] = useState(currentSeason);
    const [data, dataLoading, dataError] = useStandings(season);
    history.pushState({urlPath:'/statistik/tabell'},"",'/statistik/tabell');
    return (
        <div className="stats-table no-radius-top">
            <div className="data-container__header">
                <div className="row px-4 pt-3 pb-2 justify-content-end">
                    <StandingsFilter
                        setSeason={setSeason}
                        season={season}
                    />
                </div>
            </div>
            <div className="stats-table__row stats-table__row--header">
                <div className="stats-table__position stats-table__position--status d-none d-lg-block">Ranking</div>
                <div className="stats-table__name stats-table-team-mobile">Lag</div>
                <div className="stats-table__games">S</div>
                <div className="stats-table__wins">V</div>
                <div className="stats-table__ties">O</div>
                <div className="stats-table__losses">F</div>
                <div className="stats-table__plus-minus">+/-</div>
                <div className="stats-table__points">P</div>
            </div>
            <StandingsTable
                season={season}
                data={data}
                dataLoading={dataLoading}
            />
        </div>
    );
}
export default Standings;